import { get } from '../../01-helpers/services/ajax';

export default function IsValidNgfMember(gsn, barcode) {
    return get(
        `/api/youth/isvalidngfmember?gsn=${gsn}&barcode=${barcode}`
    );
};